import _asyncToGenerator from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

var appendScript = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(src) {
    var tag;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!document.querySelectorAll("script[src=\"".concat(src, "\"]")).length) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            tag = document.createElement('script');
            tag.src = src;
            tag.async = true;
            document.body.appendChild(tag);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function appendScript(_x) {
    return _ref.apply(this, arguments);
  };
}();

export default appendScript;